var Api={};Api.Scenario=require("./api/scenario"),module.exports=Api;